import { render } from "./News16.vue?vue&type=template&id=bfe6f856&scoped=true"
import script from "./News16.vue?vue&type=script&lang=js"
export * from "./News16.vue?vue&type=script&lang=js"

import "./News16.vue?vue&type=style&index=0&id=bfe6f856&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfe6f856"]])

export default __exports__